import { render, staticRenderFns } from "./FormSectionContainer.vue?vue&type=template&id=36e10692&scoped=true"
import script from "./FormSectionContainer.vue?vue&type=script&lang=js"
export * from "./FormSectionContainer.vue?vue&type=script&lang=js"
import style0 from "./FormSectionContainer.vue?vue&type=style&index=0&id=36e10692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e10692",
  null
  
)

export default component.exports